import { useState, useEffect, useRef } from 'react';

export const useResolvedLoading = ({ isLoading }: { isLoading: boolean }) => {
  const hasRequestedListing = useRef(false);
  const [hasResolvedLoading, setHasResolvedLoading] = useState(false);

  useEffect(() => {
    if (isLoading && !hasRequestedListing.current) {
      hasRequestedListing.current = true;
    }

    if (hasRequestedListing.current && !isLoading) {
      setHasResolvedLoading(true);
    }
  }, [isLoading]);

  return { hasResolvedLoading };
};
